import React, { useState } from "react"
import styles from "./question.module.css"
import { getMultipleResponseAnswersStatus } from "../utils/quizUtil"

const Check = () => (
  <svg viewBox="0 0 11 8" width="9" height="7" focusable="false">
    <path d="M9.6,0L11,1.3L3.9,8L0,4.3L1.4,3l2.6,2.4L9.6,0z"></path>
  </svg>
)

const Cross = () => (
  <svg viewBox="0 0 10 10" width="8" height="8" focusable="false">
    <path d="M5,4.17,9.17,0,10,.83,5.83,5,10,9.17,9.17,10,5,5.83.83,10,0,9.17,4.17,5,0,.83.83,0Z"></path>
  </svg>
)

function showAnsweredIndicator(answer, userAnswer, i) {
  if (answer[i] === "") {
    return <Cross />
  } else {
    return <Check />
  }
}
export default props => {
  const { choices } = props
  const [userAnswer, setUserAnswer] = useState(choices.map(() => ""))
  const [userAnswerStatus, setUserAnswerStatus] = useState([])
  const { qid, type, answer, answered, handleClick } = props
  const enabled = userAnswer.filter(c => c.length > 0).length

  return (
    <>
      <ul className={styles.multipleResponse}>
        {choices.map((c, i) => {
          let optionStyles = [styles.multipleResponseOption]

          if (answered) {
            if (userAnswer[i].length > 0) {
              // User selected this choice
              optionStyles.push(styles.selected)
            }
            if (userAnswerStatus.length > 0) {
              // Answers already submitted
              if (userAnswerStatus[i]) {
                optionStyles.push(styles.correct)
              } else {
                optionStyles.push(styles.incorrect)
              }
            }
          }

          return (
            <li className={optionStyles.join(" ")} key={i}>
              <button
                onClick={() => {
                  if (!answered) {
                    setUserAnswer(
                      userAnswer.map((choice, choiceIndex) => {
                        if (choiceIndex === i) {
                          if (choice.length === 0) {
                            return c
                          }

                          return ""
                        }
                        return choice
                      })
                    )
                  }
                }}
                onKeyDown={() => {
                  if (!answered) {
                    setUserAnswer(
                      userAnswer.map((choice, choiceIndex) => {
                        if (choiceIndex === i) {
                          if (choice.length === 0) {
                            return c
                          }

                          return ""
                        }
                        return choice
                      })
                    )
                  }
                }}
              >
                <label
                  htmlFor={`option-${i}`}
                  className={
                    userAnswer[i].length > 0 || answered
                      ? [styles.checkbox, styles.checked].join(" ")
                      : styles.checkbox
                  }
                >
                  {/* <input
                  id={`option-${i}`}
                  type="checkbox"
                  value={userAnswer[i]}
                /> */}
                  <div
                    aria-hidden="false"
                    className={styles.checkboxIndicator}
                    tabIndex={i}
                  >
                    {(answered &&
                      showAnsweredIndicator(answer, userAnswer[i], i)) || (
                      <Check />
                    )}
                  </div>
                  <div aria-hidden="false" className={styles.checkboxLabel}>
                    {c}
                  </div>
                </label>
              </button>
              <div className={styles.optionBorder}></div>
            </li>
          )
        })}
      </ul>
      <button
        type="button"
        disabled={!enabled}
        onClick={() => {
          const qParams = { type, answer, userAnswer }
          let answersStatus = getMultipleResponseAnswersStatus(qParams)

          setUserAnswerStatus(answersStatus)
          handleClick(qid, qParams)
        }}
        onKeyDown={() => {
          const qParams = { type, answer, userAnswer }
          let answersStatus = getMultipleResponseAnswersStatus(qParams)

          setUserAnswerStatus(answersStatus)
          handleClick(qid, qParams)
        }}
        className={
          (!enabled && styles.submit) ||
          [styles.submit, styles.enabled].join(" ")
        }
      >
        Submit
      </button>
    </>
  )
}
